import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import './index.css'
import { getEventById } from "../../../../service";
import TagHead from "../../../../components/tag/head";
import MyEventDetailSkeleton from "../../../../components/skeleton/my/myEventDetailSkeleton";
import { TopBar } from "../../../../widgets";

const EventDetail = () => {
    const { id } = useParams();
    const [eventData, setEventData] = useState<IEventBoardDetail>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!id) return;
        setLoading(true)
        getEventById(id).then(res => {
            setLoading(false);
            setEventData(res.data);
        }).catch(err => console.error(err))
    }, [id])
    return <>
        <TagHead title={eventData?.title ?? ''} imgUrl={eventData?.thumbnailImgUrl ?? ''} description="positivehotel.com" />
        <TopBar title="" rightType='share' thema='dark' />
        {(loading || !eventData) ? <MyEventDetailSkeleton /> : <div className="event-detail" dangerouslySetInnerHTML={{ __html: eventData.htmlData ?? '' }} />}
    </>
}

export default EventDetail;